import "../styles/styles.scss";
import stickyHeaderScroll  from "../js/functions/topHeader";
import { readMoreContent } from '../js/functions/careersReadMore';

document.addEventListener(
     "DOMContentLoaded",
     function() {
        stickyHeaderScroll();
        readMoreContent();
    },
     false
   );